module.exports = __webpack_public_path__ + "img/historical-plan-icon.dbf23aad.svg";